import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { DataObjectGroupUrl } from './DataObjectGroupUrl';
import {
  AUTOCOMPLETE_PAGE_SIZE,
  OptionsPage,
  OptionType,
} from '../../common/queryClient';
import { GroupDescriptionPageSchema } from '../schema/DataObjectGroupSchema';
import { useInfiniteSearchQuery } from '../../common/queryClient/useInfiniteSearchQuery';
import { QueryFunctionContext } from '@tanstack/react-query';

export interface GroupDefinitionSearchQueryParams {
  searchText?: string;
  type?: string;
  selectedCode?: string;
  page?: number;
  size?: number;
}

interface GroupDefinitionInfiniteSearchOptions {
  type?: string;
  selectedCode?: string;
}

const searchGroupDescriptions = ({
  searchText,
  type,
  selectedCode,
  page,
  size,
}: GroupDefinitionSearchQueryParams) =>
  apiClient
    .get(
      expand(DataObjectGroupUrl.AUTOCOMPLETE, {
        searchText,
        type,
        selectedCode,
        page,
        size,
      })
    )
    .then((response) => GroupDescriptionPageSchema.parse(response.data));

const searchGroupDescriptionOptions = async ({
  meta,
  pageParam,
}: QueryFunctionContext<any, number>): Promise<OptionsPage> => {
  const page = pageParam ?? 0;
  const params = meta as Partial<GroupDefinitionSearchQueryParams> | undefined;
  const result = await searchGroupDescriptions({
    ...params,
    searchText: meta?.searchText as string | undefined,
    type: meta?.type as string | undefined,
    selectedCode: meta?.selectedCode as string | undefined,
    page,
    size: AUTOCOMPLETE_PAGE_SIZE,
  });

  const content: OptionType[] = result.content.map((item) => {
    return {
      value: item.code,
      label: `${item.code} - ${item.name}`,
    };
  });
  return {
    content,
    last: result.last,
    number: result.number,
  };
};

export const useInfiniteSearchGroupDescriptionQuery = (
  term: string,
  options?: GroupDefinitionInfiniteSearchOptions
) =>
  useInfiniteSearchQuery(
    ['search-group-description-autocomplete'],
    searchGroupDescriptionOptions,
    term,
    options
  );
